import { Typography, withForm } from '@stern-ui/ui';

import { patientListFiltersFormOptions } from './patientListFiltersFormOptions';
import { PatientListFiltersFormSection } from './PatientListFiltersFormSection';

export const PatientListFiltersNumberOfPatients = withForm({
	...patientListFiltersFormOptions,
	render: ({ form }) => {
		return (
			<PatientListFiltersFormSection
				title='Number of patients'
				dataTestId='filters-patient-numbers-section'
			>
				<>
					<Typography className='text-secondaryTextDark'>
						Leave this blank to return all the patients who match your filter criteria.
					</Typography>
					<div className='grid grid-cols md:grid-cols-3 gap-4 md:gap-8 pt-4 pb-5'>
						<div className='col-span-1 md:col-span-2 pr-4 md:pr-8'>
							<form.AppField name='max_results'>
								{(field) => (
									<field.TextField
										label='Maximum number of patients'
										inputMode='numeric'
										className='max-w-[50%]'
									/>
								)}
							</form.AppField>
						</div>
					</div>
				</>
			</PatientListFiltersFormSection>
		);
	},
});
